import { TypedDocumentNode, gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import LineupSharing from '@sorare/gameplay/src/components/lineup/LineupSharing';

import field from 'components/lineup/LineupLayout/assets/field.jpg';
import { So5Lineup } from 'components/lineup/So5Lineup';

import {
  NBALineupSharingQuery,
  NBALineupSharingQueryVariables,
} from './__generated__/page.graphql';
import { PageParams } from './__generated__/routeParams';

const NBA_LINEUP_SHARING_QUERY = gql`
  query NBALineupSharingQuery($id: ID!) {
    so5 {
      so5Lineup(id: $id) {
        id
        so5LeaderboardContender {
          slug
          ...NbaSo5Lineup_so5LeaderboardContender
        }
        ...LineupSharing_so5Lineup
      }
    }
  }
  ${So5Lineup.fragments.so5LeaderboardContender}
  ${LineupSharing.fragments.so5Lineup}
` as TypedDocumentNode<NBALineupSharingQuery, NBALineupSharingQueryVariables>;

const NBALineupSharing = () => {
  const { id } = useTypedParams<PageParams>();
  const { data } = useQuery(NBA_LINEUP_SHARING_QUERY, {
    variables: {
      id,
    },
  });

  const { so5Lineup } = data?.so5 || {};
  const { so5LeaderboardContender } = so5Lineup || {};
  if (!so5Lineup || !so5LeaderboardContender) return null;

  return (
    <LineupSharing
      so5Lineup={so5Lineup}
      so5LineupNode={
        <So5Lineup so5LeaderboardContender={so5LeaderboardContender} />
      }
      field={field}
    />
  );
};

export default NBALineupSharing;
